/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Complete_ToastInputs */

const en_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentation Complete`)
};

const fr_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentation terminee`)
};

const de_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentierung abgeschlossen`)
};

const it_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentazione completa`)
};

const ru_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегментация завершена`)
};

const es_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentación completa`)
};

const zh_cn2_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割完成`)
};

const ja_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメンテーション完了`)
};

const hi_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन पूर्ण`)
};

const pt_pt2_segment_event_group_complete_toast = /** @type {(inputs: Segment_Event_Group_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentação concluída`)
};

/**
* | output |
* | --- |
* | "Segmentation Complete" |
*
* @param {Segment_Event_Group_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_complete_toast = /** @type {((inputs?: Segment_Event_Group_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_complete_toast(inputs)
	if (locale === "de") return de_segment_event_group_complete_toast(inputs)
	if (locale === "it") return it_segment_event_group_complete_toast(inputs)
	if (locale === "ru") return ru_segment_event_group_complete_toast(inputs)
	if (locale === "es") return es_segment_event_group_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_complete_toast(inputs)
	if (locale === "ja") return ja_segment_event_group_complete_toast(inputs)
	if (locale === "hi") return hi_segment_event_group_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_complete_toast(inputs)
	return en_segment_event_group_complete_toast(inputs)
});